/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type FeatureFlagNameEnum = typeof FeatureFlagNameEnum[keyof typeof FeatureFlagNameEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlagNameEnum = {
  fund_family_setup: 'fund_family_setup',
  hybrid_waterfalls: 'hybrid_waterfalls',
  credit_facility_expenses: 'credit_facility_expenses',
  display_time_weighted_returns: 'display_time_weighted_returns',
  eventing_v2: 'eventing_v2',
  validate_non_negative_commitments_distributions: 'validate_non_negative_commitments_distributions',
  cap_call_reallocations: 'cap_call_reallocations',
  backdated_cap_call_reallocations: 'backdated_cap_call_reallocations',
  credit_facility_reallocation_via_capital_calls: 'credit_facility_reallocation_via_capital_calls',
  new_allocation_rule_versions_on_draft_transactions: 'new_allocation_rule_versions_on_draft_transactions',
  hypo_waterfalls_with_custom_pnl_input: 'hypo_waterfalls_with_custom_pnl_input',
  validate_non_negative_distribution_inclusive_of_equalization: 'validate_non_negative_distribution_inclusive_of_equalization',
  use_allocation_rule_groups: 'use_allocation_rule_groups',
  waterfall_subevent: 'waterfall_subevent',
  async_workflow_improvements: 'async_workflow_improvements',
  use_fee_waiver_transaction_codes: 'use_fee_waiver_transaction_codes',
  inter_entity_fund_structure: 'inter_entity_fund_structure',
  refresh_out_of_date_events: 'refresh_out_of_date_events',
  allow_creation_of_allocation_rule_graphs_via_ui: 'allow_creation_of_allocation_rule_graphs_via_ui',
  allow_edit_of_allocation_rule_graphs_via_ui: 'allow_edit_of_allocation_rule_graphs_via_ui',
  maybern_assistant: 'maybern_assistant',
} as const;
